module.exports = __webpack_public_path__ + "img/avions.2dca9c2a.jpg";